import React from "react";
import { FaCaretDown } from "react-icons/fa";
import {
  Dropdown,
  DropdownButton,
  DropdownHeading,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
  DropdownSection,
} from "@components/Catalyst/dropdown";
import { GacDesktopNavbarItem } from "@components/Catalyst/navbar";
import { BrandCode } from "@typed/common";
import { LinkEntry } from "../data";

export const ExpansionMenuItem = ({ item, brandCode, className = "" }: { item: LinkEntry; brandCode: BrandCode; className?: string }) => {
  if (item.href) {
    return (
      <DropdownItem key={item.label} href={item.href}>
        <DropdownLabel className={className}>{item.element || item.label || ""}</DropdownLabel>
      </DropdownItem>
    );
  }

  return (
    <>
      {/* <DropdownItem
        key={item.label}
        onClick={(e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
          e.preventDefault();
          setOpen(!open);
        }}
        className={className}
      >
        <DropdownLabel className="flex w-full items-center justify-between">
          {item.element || item.label || ""}{" "}
          <ChevronDownIcon className={`transform transition-transform duration-300 ${open ? "rotate-180" : "rotate-0"} size-5`} />
        </DropdownLabel>
      </DropdownItem> */}
      <DropdownSection>
        <DropdownHeading>{item.element || item.label || ""}</DropdownHeading>

        {item.children &&
          item.children.map((childItem) => (
            <ExpansionMenuItem item={childItem} brandCode={brandCode} key={childItem.label} className="pl-4" />
          ))}
      </DropdownSection>
    </>
  );
};

const DropMenuItem = ({ item, brandCode }: { item: LinkEntry; brandCode: BrandCode }) => (
  <Dropdown>
    <DropdownButton as={GacDesktopNavbarItem} aria-label={item.label}>
      {item.element || item.label || ""}
      {!item.element && <FaCaretDown size={18} />}
    </DropdownButton>

    <DropdownMenu className={`dark bg-${brandCode}`} key={item.label}>
      {item.children &&
        item.children.map((childItem) => <ExpansionMenuItem item={childItem} brandCode={brandCode} key={childItem.label} />)}
    </DropdownMenu>
  </Dropdown>
);

export default DropMenuItem;
